import moment from 'moment/moment'

const helperMixins = {
	methods: {
		is_null: value => value == null,

		is_object: value => Object.keys(value).length > 0,

		is_bool: value => value === true || value === false,

		isArray: value => Array.isArray(value),

		scanObject: function (nestedObj, pathArr, defaultValue = null) {
			if (!this.isArray(pathArr)) {
				pathArr = pathArr.split('.')
			}
			let retrievedValue = pathArr.reduce((obj, key) => (obj && obj[key] !== 'undefined') ? obj[key] : undefined, nestedObj)
			return (!this.is_null(retrievedValue) && typeof retrievedValue !== 'undefined') ? retrievedValue : defaultValue
		},

		roundOff: function (num, decimalPlaces = 2) {
			if (num > 0) {
				let roundedNumber = +(Math.round(num + 'e+'+decimalPlaces)  + 'e-'+decimalPlaces)
				if(!isNaN(roundedNumber)) {
					return roundedNumber.toLocaleString('en-UK', {minimumFractionDigits:0, maximumFractionDigits: decimalPlaces})
				} else {
					return num
				}
			} else {
				return num
			}
		},

		getValueInHadaCurrency: function (amount) {
			if (typeof amount === 'string') {
				// means it is a native currency (XRP)
				return amount < 1000 ?
					`${this.roundOff(this.convertXRPToHada(amount))} HADA` :
					`${this.thousandsNumberFormatter(this.convertXRPToHada(amount))} HADA`
			} else {
				// means it is a token currency
				let currencyName = this.getCurrencyName(amount.currency)
				if (currencyName === 'HADA') {
					return parseFloat(amount.value) < 1000 ?
						`${this.roundOff(amount.value)} ${currencyName}` :
						`${this.thousandsNumberFormatter(amount.value)} ${currencyName}`
				} else {
					return this.convertCurrencyToHada(amount.value, currencyName)
				}
			}
		},

		getCurrencyName: function (currencyCode) {
			// currently, we only support the following: HADA, HADALITE, USD, XRP
			let currency = this.$page.props.currencies.find((currency) => {
				return currency.currency_code === currencyCode
			})
			return currency ? currency.name : currencyCode
		},

		convertXRPToHada: function (amount, isDrops = true) {
			let hadaCurrencyObject = this.$page.props.currencies.find(currency => currency.name === 'HADA')
			let xrpValue = 1 / (parseFloat(hadaCurrencyObject.rate))
			return isDrops ? (amount / 1000000) * xrpValue : amount * xrpValue
		},

		convertCurrencyToHada: function (amount, currencyName) {
			// find the currency object
			let currency = this.$page.props.currencies.find(currency => currency.name === currencyName)

			if (currency) {
				// then convert the currency to XRP then to drops
				let xrpValue = 1 / (parseFloat(currency.rate))
				let xrpAmount = (amount / xrpValue) * 1000000
				// lastly convert the XRP equivalent to HADA
				return `${this.thousandsNumberFormatter(this.convertXRPToHada(xrpAmount))} HADA`
			} else {
				return 'unsupported currency'
			}
		},

		convertDropsToXrp: function (amount, addSuffixCurrency = true) {
			let xrpAmount = (parseFloat(amount) / 1000000)
			return xrpAmount < 1000 ?
				`${this.roundOff(xrpAmount, 6)} ${addSuffixCurrency ? 'XRP' : ''}` :
				`${this.thousandsNumberFormatter(xrpAmount)} ${addSuffixCurrency ? 'XRP' : ''}`
		},

		offerInXrp: function (amount) {
			let isOfferInXrp = false
			if (typeof amount === 'string') {
				isOfferInXrp = true
			}
			return isOfferInXrp
		},

		getXrpAndUsdPairValuesOfToken: function (tokenCurrency) {
			if(!this.is_null(tokenCurrency.currencyDetails) && typeof tokenCurrency.currencyDetails !== 'undefined') {
				let xrpRate = parseFloat(tokenCurrency.currencyDetails.rate) !== 0 ? 1 / (parseFloat(tokenCurrency.currencyDetails.rate)) : 0
				let usdRate = 1 / parseFloat(tokenCurrency.xrpToUsdRate.rate)

				let xrpValue = xrpRate !== 0 ? parseFloat(tokenCurrency.balance) / xrpRate : 0
				let usdValue = xrpValue * usdRate

				return [this.roundOff(xrpValue), this.roundOff(usdValue)]
			} else {
				return [0, 0]
			}
		},

		getValueOfXrpInUSd: function (xrpBalanceObject) {
			let usdRate = 1 / parseFloat(xrpBalanceObject.xrpToUsdRate.rate)
			let usdValue = (parseFloat(xrpBalanceObject.Balance) / 1000000) * usdRate
			return this.roundOff(usdValue)
		},

		thousandsNumberFormatter: function ($num) {
			let $x = Math.round($num)
			let $formatted_number = $x.toLocaleString('en-UK', {
				maximumFractionDigits: 0,
				minimumFractionDigits: 0
			})

			if ($x >= 1000) {
				let splitValues = $formatted_number.split(',')
				let $x_parts = ['K', 'M', 'B', 'T']
				let $x_count_parts = splitValues.length - 1
				$x = splitValues[0] + (Number(splitValues[1][0]) !== 0 ? '.' + splitValues[1][0] : '')
				$x += $x_parts[$x_count_parts - 1]
				return $x
			}
			return $formatted_number
		},

		convertSecondsToMinutesTime: function (seconds) {
			let hr = Math.floor(seconds / 3600).toString().padStart(2, '0')
			let min = Math.floor(seconds % 3600 / 60).toString().padStart(2, '0')
			let sec = Math.floor(seconds % 60).toString().padStart(2, '0')

			return `${hr} hrs ${min} mins ${sec} secs`
		},

		formatDate: function (date, longDateFormat = 'Do MMMM, YYYY') {
			if (this.$dayjs.tz(date).isSame(this.$dayjs.tz(), 'day')) {
				return `Today at ${this.$dayjs.tz(date).format('HH:mm')}`
			}
			if ((this.$dayjs.tz(date).isSame(this.$dayjs.tz().subtract(1, 'days').startOf('day'), 'day'))) {
				return `Yesterday at ${this.$dayjs.tz(date).format('HH:mm')}`
			} else {
				return `${this.$dayjs.tz(date).format(longDateFormat)}`
			}
		},

		formatXrplTransactionName: function (transactionType) {
			switch(transactionType) {
			case 1:
				return 'Minted'
			case 2:
				return 'Buy Offer Created'
			case 3:
				return 'Sell Offer Created'
			case 4:
				return 'Buy Offer Accepted'
			case 5:
				return 'Sell Offer Accepted'
			case 6:
				return 'Buy Offer cancelled'
			case 7:
				return 'Sell Offer cancelled'
			case 8:
				return 'Burnt'
			case 9:
				return 'Unknown Transaction'
			default:
				return 'Unknown Transaction'
			}
		},

		formatXrplTransactionDate: function (date) {
			let day = moment('Jan 1, 2000')
			day.add('s', date)
			return this.formatDate(day, 'DD/MM/YYYY HH:mm')
		},

		formatXrplTransactionVolume: function (amount, currency_code) {
			let txVolume, indicativeAmount = null
			let hadaCurrencyObject = this.$page.props.currencies.find(currency => currency.name === 'HADA')
			if(currency_code === 'XRP') {
				let hadaAmount = this.convertXRPToHada(amount, false)
				indicativeAmount = amount < 1000 ? `${this.roundOff(amount)} XRP` : `${this.thousandsNumberFormatter(amount)} XRP`
				txVolume = hadaAmount < 1000 ? `${this.roundOff(hadaAmount)} HADA` : `${this.thousandsNumberFormatter(hadaAmount)} HADA`
			} else if (currency_code === hadaCurrencyObject.currency_code) {
				txVolume = amount < 1000 ? `${this.roundOff(amount)} HADA` : `${this.thousandsNumberFormatter(amount)} HADA`
			} else {
				let currencyName = this.getCurrencyName(currency_code)
				indicativeAmount = amount < 1000 ? `${this.roundOff(amount)} ${currencyName}` : `${this.thousandsNumberFormatter(amount)} ${currencyName}`
				txVolume = this.convertCurrencyToHada(amount, currencyName)
			}

			return !this.is_null(indicativeAmount) ? `${indicativeAmount} <br> (${txVolume})` : txVolume
		},

		truncateString: function (string, chars = 10) {
			if(string.length <= chars) return string
			return `${string.slice(0, chars)}...${string.slice(-3)}`
		},

		truncateStringAlt: function (string, chars = 10) {
			if(string.length < chars) return string
			return `${string.slice(0, chars)}...`
		},

		slugifyString: function  (str) {
			return str
				.normalize('NFD') // split an accented letter in the base letter and the accent
				.replace(/[\u0300-\u036f]/g, '') // remove all previously split accents
				.toLowerCase()
				.trim()
				.replace(/[^A-Za-z0-9-]+/g, '-') // remove all chars not letters, numbers and spaces (to be replaced)
				.replace(/\s+/g, '-') // separator
		},

		getImage: function (cid) {
			let id = this.slugifyString(cid)
			return document.getElementById(id).src
		},

		puzzlePieceType: function (type) {
			switch(type) {
			case 'piece':
				return 'pPFP'
			case 'row':
				return 'Row'
			case 'pfp':
				return 'PFP'
			default:
				return 'pPFP'
			}
		},

		paginate: function (url) {
			this.loading = true
			axios.get(url).then(response => {
				this.offers = response.data
				this.loading = false
			})
		},

		formatCollectibleName(collectible) {
			let string = collectible.file_path
			const startIndex = string.indexOf(' ') + 1 // Find the index of the first space and add 1 to get the start of the first desired string

			if (collectible.type === 1) {
				const endIndex = string.lastIndexOf('.') // Find the index of the last period to get the end of the desired string
				return string.slice(startIndex, endIndex)
			} else if(collectible.type === 2) {
				const startIndex = string.indexOf(' ') + 1 // Find the index of the first space and add 1 to get the start of the desired string
				const endIndex = string.indexOf('/rows/') // Find the index of the substring "/pieces/" to get the end of the desired string
				const extractedString = string.slice(startIndex, endIndex) // Use the slice method to extract the desired string
				const rowColumnString = string.substring(string.lastIndexOf('/') + 1, string.lastIndexOf('.')) // Extract the "row-column" string from the input string
				 // Concatenate the extracted string with the "row-column" string and add a <br/> tag
				return `${extractedString} <br/> ${rowColumnString}`
			} else {
				const startIndex = string.indexOf(' ') + 1 // Find the index of the first space and add 1 to get the start of the desired string
				const endIndex = string.indexOf('/pieces/') // Find the index of the substring "/pieces/" to get the end of the desired string
				const extractedString = string.slice(startIndex, endIndex) // Use the slice method to extract the desired string
				const rowColumnString = string.substring(string.lastIndexOf('/') + 1, string.lastIndexOf('.')) // Extract the "row-column" string from the input string
				 // Concatenate the extracted string with the "row-column" string and add a <br/> tag
				return `${extractedString} <br/> ${rowColumnString}`
			}
		}
	}
}

export default helperMixins
